import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-service-faq',
  templateUrl: './service-faq.component.html',
  styleUrls: ['./service-faq.component.scss']
})
export class ServiceFaqComponent {
  @Input() serviceFaqs: { question: string, answer: string }[];
  @Input() game: string;
  @Input() service: string;

  gameTitle = {
    apex: 'Apex Legends',
    cs2: 'Counter Strike 2',
    valorant: 'Valorant',
    lol: 'LoL',
    tft: 'TFT',
    'wild-rift': 'Wild Rift',
    marvel: 'Marvel Rivals'
  };

  faqColors = ['#9853ff', '#ff5353', '#2ec565',
    '#345fdb', '#ffbb34', '#ff9253',
    '#3fafd7', '#d988d9', '#51af8a'];
  public colorNumber = -1;

  increaseColor() {
    this.colorNumber++;
    return this.colorNumber;
  }
}